import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import {
	Checkbox,
	CircularProgress,
	Divider,
	InputLabel,
	Modal,
	Step,
	StepContent,
	StepLabel,
	Stepper,
	TextField,
} from "@mui/material";
import ServiceDetail1 from "../../assets/serviceDetail1.png";
import Book1 from "../../assets/book1.png";
import Cart1NoCoupon from "../../assets/cart1-nocoupon.png";
import Book2 from "../../assets/book2.png";
import Book3 from "../../assets/book3.png";
import Book4 from "../../assets/book4.png";
import Cart5 from "../../assets/cart5.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { InfoCircle } from "tabler-icons-react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
		overflow: "auto",
		padding: 20,
		width: "100%",
		justifyContent: "center",
		flexWrap: "wrap",
	},
	cardGrid: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
});

export default function BookingProcessServices({ drawerWidth }) {
	const classes = useStyles();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [showCoupon, setShowCoupon] = useState(true);
	const [shippingMethod, setShippingMethod] = useState("");
	const [shippingAddress, setShippingAddress] = useState("");
	const [shippingBillingAddress, setShippingBillingAddress] = useState("");
	const [cartCreditCard, setCartCreditCard] = useState("");
	const [platformSettings, setPlatformSettings] = useState("");
	const [stripeKey, setStripeKey] = useState("");
	const [showStripeModal, setShowStripeModal] = useState(false);
	const { t } = useTranslation();
	const { user } = useContext(UserContext);

	const saveCartData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					useCoupon: showCoupon,
					cartShippingAddress: shippingAddress,
					cartShippingMethod: shippingMethod,
					cartShippingBillingAddress: shippingBillingAddress,
					cartCreditCard: cartCreditCard,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			await axios.put(
				ADMIN_URL + "platformSettings/" + platformSettings.id,
				{
					stripeKey: stripeKey,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [
		showCoupon,
		shippingAddress,
		shippingMethod,
		shippingBillingAddress,
		cartCreditCard,
		platformSettings,
		stripeKey,
	]);

	useEffect(() => {
		const getCartData = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "creators", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setShowCoupon(res.data.useCoupon);
				setShippingMethod(res.data.cartShippingMethod);
				setShippingAddress(res.data.cartShippingAddress);
				setShippingBillingAddress(res.data.cartShippingBillingAddress);
				setCartCreditCard(res.data.cartCreditCard);
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};
		const getStripeKey = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "platformSettings", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setPlatformSettings(res.data[0]);
				setStripeKey(res.data[0].stripeKey);
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};

		getCartData();
		getStripeKey();
	}, []);

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
				}}>
				<Toolbar />

				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									height: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px",
								}}
								color="text.secondary"
								gutterBottom>
								{t("bookingProcess.title")}
							</Typography>
							<div className={classes.cardInfo}>
								{/*<Box sx={{ width: "100%" }}>
									<ul>
										<li>
											<Typography>{t("bookingProcess.point1")}</Typography>
										</li>
										<li>
											<Typography>{t("bookingProcess.point2")}</Typography>
										</li>
										<li>
											<Typography>{t("bookingProcess.point3")}</Typography>
										</li>
										<li>
											<Typography>{t("bookingProcess.point4")}</Typography>
										</li>
									</ul>
							</Box>*/}
								<Box
									container
									className={classes.cardForm}
									sx={{
										flexDirection: {
											xs: "column",
											sm: "column",
											md: "column",
											lg: "row",
										},
										alignItems: {
											xs: "center",
											sm: "center",
											md: "center",
											lg: "flex-start",
										},
									}}>
									<Box
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
										sx={{ marginBottom: 4 }}>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary">
											{t("bookingProcess.page")} 1 (
											{t("bookingProcess.optional")})
										</Typography>

										<img src={Book1} alt="iphone" className={classes.iphone} />
										<Typography
											sx={{
												textAlign: "center",
												padding: "0 10px",
												maxWidth: "340px",
											}}>
											{t("bookingProcess.point1")}
										</Typography>
									</Box>
									<Box
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
										sx={{ marginBottom: 4 }}>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary">
											{t("bookingProcess.page")} 2
										</Typography>
										<img src={Book2} alt="iphone" className={classes.iphone} />
										<Typography
											sx={{
												textAlign: "center",
												padding: "0 10px",
												maxWidth: "340px",
											}}>
											{t("bookingProcess.point2")}
										</Typography>
										<Link
											href="#"
											variant="body2"
											sx={{
												color: "#43BD98",
												textDecoration: "none",
												marginTop: 2,
												marginBottom: {
													xs: 4,
													sm: 4,
													md: 0,
												},
											}}
											onClick={() => {
												navigate("/calendar");
											}}>
											{t("bookingProcess.changeDesign")}
										</Link>
									</Box>
									<Box
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
										sx={{ marginBottom: 4 }}>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary">
											{t("bookingProcess.page")} 3
										</Typography>
										<img src={Book3} alt="iphone" className={classes.iphone} />
										<Typography
											sx={{
												textAlign: "center",
												padding: "0 10px",
												maxWidth: "340px",
											}}>
											{t("bookingProcess.point3")}
										</Typography>
									</Box>
									<Box
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary">
											{t("bookingProcess.page")} 4
										</Typography>
										<img src={Book4} alt="iphone" className={classes.iphone} />
										<Typography
											sx={{
												textAlign: "center",
												padding: "0 10px",
												maxWidth: "340px",
											}}>
											{t("bookingProcess.point4")}
										</Typography>
										<Link
											href="#"
											variant="body2"
											sx={{
												color: "#43BD98",
												textDecoration: "none",
												marginTop: 2,
											}}
											onClick={() => {
												navigate("/your-appointments");
											}}>
											{t("bookingProcess.changeDesign")}
										</Link>
									</Box>
								</Box>
							</div>
						</CardContent>
					</>
				</Card>
			</Box>
		</>
	);
}
